module.exports = __webpack_public_path__ + "img/urole_dsh.ebc7ab63.png";